import { useState } from 'react';

import { Stack, Box } from '@mui/material';

import Tabs from '@/components/common/Tabs';
import { useIsSmallScreen } from '@/utils/mediaUtil';

import PageContainer from '../PageContainer';
import { ContentRow, GoalsContainer } from './GoalsStyles';
import GoalBox from './components/GoalBox';
import PeriodDropdown from './components/PeriodDropdown';
import StrategicPlan from './components/StrategicPlan';
import useGoalsLogic from './hooks/useGoalsLogic';

const GoalsPage = () => {
  const isSmallScreen = useIsSmallScreen();
  const [activeTab, setActiveTab] = useState(0);

  const { periods, selectedPeriod, setSelectedPeriod, sortedGoals, dueDate, monthToStart } =
    useGoalsLogic();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  const GoalsContent = () => (
    <GoalsContainer>
      <PeriodDropdown
        periods={periods}
        selectedPeriod={selectedPeriod}
        onPeriodChange={setSelectedPeriod}
      />
      {Array.from({ length: 3 }).map((_, index) => (
        <GoalBox
          key={index}
          dueDate={dueDate || ''}
          goal={sortedGoals?.[index] ? sortedGoals[index] : undefined}
        />
      ))}
    </GoalsContainer>
  );

  if (isSmallScreen) {
    return (
      <PageContainer isBackButtonVisible={false} sx={{ paddingBottom: '40px' }}>
        <Stack sx={{ width: '100%', height: '100%', gap: '16px' }}>
          <Tabs
            tabIndex={activeTab}
            tabs={[
              { label: 'Goals', value: 0 },
              { label: 'Strategic Plan', value: 1 }
            ]}
            onTabChange={handleTabChange}
          />
          <Box role="tabpanel" hidden={activeTab !== 0}>
            {activeTab === 0 && <GoalsContent />}
          </Box>
          <Box role="tabpanel" hidden={activeTab !== 1} sx={{ height: '100%' }}>
            {activeTab === 1 && (
              <StrategicPlan
                selectedPeriod={selectedPeriod}
                goals={sortedGoals}
                monthToStart={monthToStart}
              />
            )}
          </Box>
        </Stack>
      </PageContainer>
    );
  }

  return (
    <PageContainer isBackButtonVisible={false} sx={{ paddingBottom: '40px' }}>
      <ContentRow>
        <GoalsContent />
        <StrategicPlan
          selectedPeriod={selectedPeriod}
          goals={sortedGoals}
          monthToStart={monthToStart}
        />
      </ContentRow>
    </PageContainer>
  );
};

export default GoalsPage;
